import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type FieldMatchingStore = {
  uploadedFileColumnsNumber: number;
  uploadedFileRowsNumber: number;

  actions: {
    setUploadedFileColumnsNumber: (columnsNumber: number) => void;
    setUploadedFileRowsNumber: (rowsNumber: number) => void;
  };
};

export const useFieldMatchingStore = create<FieldMatchingStore>()(
  devtools(
    set => ({
      uploadedFileColumnsNumber: 0,
      uploadedFileRowsNumber: 0,

      actions: {
        setUploadedFileColumnsNumber: columnsNumber =>
          set({ uploadedFileColumnsNumber: columnsNumber }, false, 'setUploadedFileColumnsNumber'),
        setUploadedFileRowsNumber: rowsNumber =>
          set({ uploadedFileRowsNumber: rowsNumber }, false, 'setUploadedFileRowsNumber'),
      },
    }),
    {
      name: 'field-matching-store',
      enabled: import.meta.env.DEV,
    },
  ),
);

export const useUploadedFileColumnsNumber = () => useFieldMatchingStore(state => state.uploadedFileColumnsNumber);
export const useUploadedFileRowsNumber = () => useFieldMatchingStore(state => state.uploadedFileRowsNumber);

export const useFieldMatchingStoreActions = () => useFieldMatchingStore(state => state.actions);
